// extracted by mini-css-extract-plugin
export default {"container":"MainContainer_container__8sMjk"};